<template>
  <layout-report-step
    :md="md"
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :debug="[user, contact]"
  >
    <v-card flat max-width="500" class="pt-4 pl-4 pr-4">
      <v-form ref="form" v-model="valid">
        <v-text-field
          :label="$t('report.formPersonalDataAlt.companyName')"
          v-model="companyName"
          required
          data-test-form-numberplate
          outlined
        ></v-text-field>

        <v-text-field
          v-model="user.firstName"
          :label="$t('report.formPersonalData.firstName')"
          :rules="noNumberRule"
          required
          data-test-form-firstName
          outlined
        ></v-text-field>
        <v-text-field
          v-model="user.lastName"
          :label="$t('report.formPersonalData.lastName')"
          :rules="noNumberRule"
          required
          data-test-form-lastName
          outlined
        >
        </v-text-field>
        <v-text-field
          :label="$t('report.formPersonalData.phone')"
          v-model="contact.phone"
          type="tel"
          :rules="phoneNumberRules"
          required
          data-test-form-phone
          outlined
        ></v-text-field>
        <v-text-field
          :label="$t('report.formPersonalData.mail')"
          v-model="contact.email"
          type="email"
          :rules="emailRules"
          autocomplete="email"
          required
          data-test-form-email
          outlined
        ></v-text-field>
      </v-form>
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { emailRule, noNumberRule, phoneRule } from "@/lib/rules/contactRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { IContact } from "@/models/User/IContact";
import { IUser } from "@/models/User/IUser";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { UserModule } from "@/store/modules/me-user.store";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ReportFormPersonalDataAlt extends ReportStepMixin implements IReportStep {
  public md = 4;
  public static screenName = ReportScreenEnum.contactdetails;
  public header: IReportHeaderData = {
    title: "report.formPersonalData.title",
    description: "report.formPersonalData.description"
  };

  screen = ReportScreenEnum.contactalt;

  phone: any;

  valid = false;

  mounted() {
    if (UserModule.user) {
      ReportModule.setUser({
        firstName: UserModule.user?.firstName ?? "",
        lastName: UserModule.user?.lastName ?? ""
      });
      ReportModule.setContact({
        email: UserModule.user?.contact?.email ?? "",
        phone: UserModule.user?.contact?.phone ?? ""
      });
      ReportModule.setCompanyName(UserModule.user?.company ?? "");
    }
  }

  get isDone() {
    return this.valid;
  }

  get user(): IUser {
    return ReportModule.user;
  }

  set user(user: IUser) {
    ReportModule.setUser(user);
  }

  get companyName(): string {
    return ReportModule.companyName;
  }

  set companyName(companyName: string) {
    ReportModule.setCompanyName(companyName);
  }

  get contact(): IContact {
    return ReportModule.contact;
  }

  set contact(contact: IContact) {
    ReportModule.setContact(contact);
  }

  get noNumberRule() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(noNumberRule());

    return rules;
  }

  get emailRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(emailRule());

    return rules;
  }

  get phoneNumberRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(phoneRule());

    return rules;
  }
}
</script>

<style></style>
